import findMatchingSchemaFieldForColumn from 'notebook/structured-tables/columns/findMatchingSchemaFieldForColumn';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

import {StructuredTableColumn} from '../StructuredTableConstants';

/**
 * This can happen if a schema field has been deleted after a table is created with a corresponding column.
 */
export default function isMissingFieldColumn(
  structuredTableColumn: StructuredTableColumn,
  tableSchemas: ReadonlyArray<{allFields: Array<SchemaField>}>
): boolean {
  if (structuredTableColumn.columnType !== TableColumnType.TAG_VALUE) {
    return false;
  }
  return (
    structuredTableColumn.schemaFieldApiId == null ||
    findMatchingSchemaFieldForColumn(tableSchemas, structuredTableColumn) == null
  );
}
